import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Box,
  Divider,
  Grid,
  Badge,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { SaktiSpbListItem } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiSpbDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: SaktiSpbListItem | null;
}

const SaktiSpbDetailModal: React.FC<SaktiSpbDetailModalProps> = ({ isOpen, onClose, data }) => {
  if (!data) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent borderRadius={SAKTI_UI_SIZE.cardRadius}>
        <ModalHeader bg="customGreen.500" color="white" borderRadius={`${SAKTI_UI_SIZE.cardRadius} ${SAKTI_UI_SIZE.cardRadius} 0 0`}>
          Detail SPB - {data.transport_nbr}
        </ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody py={6}>
          <VStack align="stretch" spacing={4}>
            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
              <Box>
                <Text fontSize="xs" color="gray.500">Estate / Divisi</Text>
                <Text fontWeight="bold">{data.estate_name} - {data.division_name}</Text>
                <Text fontSize="xs" color="gray.500">{data.company_name}</Text>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Tanggal</Text>
                <Text fontWeight="semibold">{dayjs(data.transport_date).format('DD MMMM YYYY HH:mm')}</Text>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Kendaraan</Text>
                <Text fontWeight="semibold">{data.equipment_code} ({data.equipment_name})</Text>
                <Text fontSize="xs" color="gray.500">Transporter: {data.transporter_name}</Text>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Driver</Text>
                <Text fontWeight="semibold">{data.driver_name}</Text>
                <Text fontSize="xs" color="gray.500">NIP: {data.driver_nip}</Text>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Status</Text>
                <Badge colorScheme={data.status === 'COMPLETED' ? 'green' : 'blue'}>{data.status}</Badge>
                <Badge ml={2} colorScheme={data.is_external ? 'orange' : 'blue'}>{data.is_external ? 'External' : 'Internal'}</Badge>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Harvest Count</Text>
                <Text fontWeight="semibold">{data.harvest_count} BCC</Text>
              </Box>
            </Grid>
            <Divider />
            <Grid templateColumns="repeat(3, 1fr)" gap={4}>
              <Box>
                <Text fontSize="xs" color="gray.500">Total Janjang</Text>
                <Text fontSize="xl" fontWeight="bold">{data.total_bunch}</Text>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Total Brondolan</Text>
                <Text fontSize="xl" fontWeight="bold">{data.total_loose_fruit.toFixed(1)} kg</Text>
              </Box>
              <Box textAlign="right">
                <Text fontSize="xs" color="gray.500">Total Berat</Text>
                <Text fontSize="xl" fontWeight="bold">{data.total_weight.toLocaleString('id-ID')} kg</Text>
              </Box>
            </Grid>
          </VStack>
        </ModalBody>
        <ModalFooter bg="gray.50" borderRadius={`0 0 ${SAKTI_UI_SIZE.cardRadius} ${SAKTI_UI_SIZE.cardRadius}`}>
          <Button onClick={onClose}>Tutup</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SaktiSpbDetailModal;
